import React, { useEffect, useMemo, useState } from 'react';
import { useQuery } from '@apollo/client';
import { Select } from 'antd';
import { queries } from '../../graphql/graphql';
import { UserRole } from '../../types/user';

interface UserSearchSelectProps {
  value?: string;
  onChange?: (value?: string) => void;
  placeholder?: string;
  role?: UserRole;
  excludeUserIds?: string[];
  pageSize?: number;
  disabled?: boolean;
}

export const UserSearchSelect: React.FC<UserSearchSelectProps> = ({
  value,
  onChange,
  placeholder = 'Search user by name or email',
  role,
  excludeUserIds = [],
  pageSize = 20,
  disabled = false,
}) => {
  const [search, setSearch] = useState('');

  const { data, loading } = useQuery(queries.users.USERS, {
    variables: {
      page: 1,
      pageSize,
      search: search || null,
      role: role || null,
    },
    // skip: !search,
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    if (!value) {
      setSearch('');
    }
  }, [value]);

  const options = useMemo(() => {
    const users = data?.users?.items || [];
    return users
      .filter((user: { id: string }) => !excludeUserIds.includes(user.id))
      .map((user: { id: string; name: string; email: string }) => ({
        label: `${user.name} (${user.email})`,
        value: user.id,
      }));
  }, [data, excludeUserIds]);

  return (
    <Select
      showSearch
      value={value}
      placeholder={placeholder}
      onSearch={value => setSearch(value)}
      onChange={nextValue => onChange?.(nextValue)}
      filterOption={false}
      options={options}
      loading={loading}
      disabled={disabled}
      allowClear
      onClear={() => setSearch('')}
    />
  );
};
